<button
  class="btn speedy-button {{ buttonClass }}"
  [ngClass]="{ 'speedy-button-outline': outline }"
  [disabled]="loading || disabled"
  (click)="clicked.emit()"
>
  @if (iconPrefix) {
    <mat-icon class="speedy-button__icon-prefix" [svgIcon]="iconPrefix"></mat-icon>
  }
  <span translate class="speedy-button__text">{{ text }}</span>
  @if (iconSuffix) {
    <mat-icon class="speedy-button__icon-suffix" [svgIcon]="iconSuffix"></mat-icon>
  }
  @if (loading) {
    <div class="speedy-button__loading">
      <mat-spinner [diameter]="spinnerSize"></mat-spinner>
    </div>
  }
  @if (loadingSuccess) {
    <div class="speedy-button__success">
      <mat-icon>done</mat-icon>
    </div>
  }
</button>
